"use strict";

var webAudioBuilder = require("./lib/builders/webaudio.js");

module.exports = webAudioBuilder;
